/* src/app/components/filter-test-category/filter-test-category.component.scss */
.filter-header-container {
  display: flex;
  align-items: center;
}
.filter-header-container .filter-header {
  display: inline;
  color: #615e5e;
  margin: 0;
}
.filter-header-container .close-button {
  width: 24px;
  height: 24px;
  padding: 0;
  margin-left: auto;
}
.checkbox-label {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  font-weight: normal;
  padding: 0;
}
.checkbox-label input[type=checkbox] {
  margin-top: 0;
}
.checkbox-label span input[type=checkbox] {
  margin-top: 5px;
}
.filter-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.question-list {
  list-style: none;
  padding: 0;
}
.question-list .question-item {
  padding: 5px 10px;
  font-size: 13px;
}
.checkbox-right-margin {
  margin-right: 5px;
}
.accordion-header {
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-weight: normal;
  color: inherit;
  line-height: inherit;
}
/*# sourceMappingURL=filter-test-category.component.css.map */
